import { Project } from '@/app/api';
import { pushArrayToDataLayer } from '@/app/hooks/useAnalytics/push-to-data-layer';
import { GoogleTagManagerEventNames } from '@/app/hooks/useAnalytics/types';

export const pushAdditionalGaIds = (event: GoogleTagManagerEventNames, project: Project) => {
  pushArrayToDataLayer([
    { event },
    { extraFacebookPixelId: project.settings.analytics.facebookPixelId },
    { extraSklikRetargetingId: project.settings.analytics.sklikRetargetingId },
    { extraGoogleAnalyticsId: project.settings.analytics.googleAnalyticsId },
    { extraGoogleAnalytics4Id: project.settings.analytics.googleAnalytics4Id },
    { extraGoogleAdsId: project.settings.analytics.googleAdsId },
    { extraTikTokPixelId: project.settings.analytics.tikTokPixelId },
  ]);
};
